export const cactusEvents = `
window.cactusEvents = window.cactusEvents || [];
window.cactusLoadedEvents = window.cactusLoadedEvents || [];
window.cactusEventsInitLoaded = window.cactusEventsInitLoaded || {};
if(!window.cactusEventsInitLoaded['cactusEvents']){
  window.cactusEventsInitLoaded['cactusEvents'] = true;
  if(window.cactusEvents){
    window.cactusEvents._push = window.cactusEvents.push;
    window.cactusEvents.push = function(data){
      if(window.cactusLoadedEvents[data[0]]){
        try{
          data[1]&&data[1]();
        }catch(ex){
          console.error('err custom event cactus push',ex);
        }
        return;
      }
      this._push.apply(this,arguments);
    }
  }

  function execCactusEvents(eventName){
    return function(){
      window.cactusLoadedEvents = window.cactusLoadedEvents || [];
      window.cactusLoadedEvents[eventName] = true;
      if(window.cactusEvents){
        window.cactusEvents.forEach(function (data, index) {
          if(!Array.isArray(data)){
            return;
          }
          const event = data[0];
          if(event === 'push' || event === '_push'){
            return;
          }
          if(!Array.isArray(window.cactusEvents[index])){
            return;
          }
          if(window.cactusEvents[index][2] === 'loaded'){
            return;
          }
          if(event === eventName){
            window.cactusEvents[index][2] = 'loaded';
            try{
              window.cactusEvents[index][1]&&window.cactusEvents[index][1]();
              window.cactusEvents[index][1] = null;
            }catch(ex){
              console.error('err custom event cactus',ex);
            }
          }
        });
      }
    }
  }
}
`;
